import { absoluteUrl } from "../seo/siteUrl";

const AREA_SERVED = [
  { "@type": "City", name: "Ahmedabad" },
  { "@type": "AdministrativeArea", name: "Gujarat" },
  { "@type": "Country", name: "India" },
];

const ADDRESS = {
  "@type": "PostalAddress",
  streetAddress:
    "A-107, Krish Elite, Beside HP Petrol Pump, Nr Vishal Land Mark, B/H Sankalp School, Sardar Patel Ring Rd, Nikol",
  addressLocality: "Ahmedabad",
  addressRegion: "Gujarat",
  postalCode: "382350",
  addressCountry: "IN",
};

/**
 * Service + Event-oriented structured data for event category landing pages.
 * Provider @id matches {@link buildLocalBusinessSchema} `#business`.
 */
export function buildCategoryPageGraph({
  pagePath,
  serviceName,
  serviceDescription,
  eventName,
  eventDescription,
}) {
  const bizId = `${absoluteUrl("/")}#business`;
  const pageUrl = absoluteUrl(pagePath);

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": `${pageUrl}#service`,
        name: serviceName,
        description: serviceDescription,
        url: pageUrl,
        serviceType: serviceName,
        provider: { "@id": bizId },
        areaServed: AREA_SERVED,
        audience: {
          "@type": "Audience",
          audienceType: "Business and consumer event clients in Gujarat and India",
        },
      },
      {
        "@type": "Event",
        "@id": `${pageUrl}#event-focus`,
        name: eventName,
        description: eventDescription,
        eventAttendanceMode:
          "https://schema.org/OfflineEventAttendanceMode",
        location: {
          "@type": "Place",
          name: "Panthi Events — Ahmedabad",
          address: ADDRESS,
        },
        organizer: { "@id": bizId },
        performer: { "@id": bizId },
        offers: {
          "@type": "Offer",
          url: pageUrl,
          availability: "https://schema.org/InStock",
          price: "0",
          priceCurrency: "INR",
          description:
            "Consultation and planning for event services — contact for quotes",
        },
      },
    ],
  };
}
